import { PencilIcon, PhotoIcon, TrashIcon } from "@heroicons/react/24/outline";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableCell,
  TableRow,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { GrDocumentPdf } from "react-icons/gr";

export const fileIcons = {
  "image/png": PhotoIcon,
  "image/jpeg": PhotoIcon,
  "application/pdf": GrDocumentPdf,
};

export default function DocumentsTable(props) {
  const { documents, onDeleteClick, onEditClick, showActions } = props;

  return (
    <Table>
      <TableHead>
        <TableHeader>Reference Document</TableHeader>
        {showActions && <TableHeader>Action</TableHeader>}
      </TableHead>
      <TableBody>
        {documents.map((document, index) => {
          const { referenceFor, filename, mimeType } = document;

          const FileIcon = fileIcons[mimeType];

          return (
            <TableRow>
              <TableCell>
                <div className="flex gap-x-4 items-start">
                  {FileIcon && <FileIcon className="size-8" />}
                  <div className="flex flex-col">
                    <p className="font-semibold">{referenceFor}</p>
                    <p className="font-light">File: {filename}</p>
                  </div>
                </div>
              </TableCell>
              {showActions && (
                <TableCell>
                  <div className="flex gap-x-2 items-center">
                    <Button
                      outline
                      onClick={() => onEditClick(document, index)}
                    >
                      <PencilIcon />
                    </Button>
                    <Button
                      outline
                      onClick={() => onDeleteClick(document)}
                    >
                      <TrashIcon />
                    </Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
